import './Calenders.scss';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';               // Hindu
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'; // Indian
import TempleHinduOutlinedIcon from '@mui/icons-material/TempleHinduOutlined';   // Tamil
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';                   // Malayalam
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';           // Sankranti
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';   // Diwali
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';   // Durga Puja
import Brightness5OutlinedIcon from '@mui/icons-material/Brightness5Outlined';   // Sharad Navratri
import Brightness4OutlinedIcon from '@mui/icons-material/Brightness4Outlined';   // Chaitra Navratri
import WavesOutlinedIcon from '@mui/icons-material/WavesOutlined';               // Odia
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';         // Bengali
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';           // Gujrati
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined'; // Marathi
import NightlightOutlinedIcon from '@mui/icons-material/NightlightOutlined';     // Telegu
import SelfImprovementOutlinedIcon from '@mui/icons-material/SelfImprovementOutlined'; // Iskon

import { Link } from 'react-router-dom';

const Calenders = ({ onClose }) => {
  return (
    <div className="Cal-modal-overlay" onClick={onClose}>
      <div className="Cal-modal-content" onClick={e => e.stopPropagation()}>
        <div className="calender-container">
          <h2>Calenders</h2>
          <div className="calender-grid">

            <Link to="/calender/hindu" className="calender-item">
              <TodayOutlinedIcon className='icon' />
              <div><h4>Hindu</h4></div>
            </Link>

            <Link to="/calender/indian" className="calender-item">
              <EventAvailableOutlinedIcon className='icon' />
              <div><h4>Indian</h4></div>
            </Link>

            <Link to="/calender/tamil" className="calender-item">
              <TempleHinduOutlinedIcon className='icon' />
              <div><h4>Tamil</h4></div>
            </Link>

            <Link to="/calender/malyalam" className="calender-item">
              <SpaOutlinedIcon className='icon' />
              <div><h4>Malyalam</h4></div>
            </Link>

            <Link to="/calender/sankranti" className="calender-item">
              <WbSunnyOutlinedIcon className='icon' />
              <div><h4>Sankranti</h4></div>
            </Link>

            <Link to="/calender/diwali" className="calender-item">
              <CelebrationOutlinedIcon className='icon' />
              <div><h4>Diwali</h4></div>
            </Link>

            <Link to="/calender/durgapuja" className="calender-item">
              <AutoAwesomeOutlinedIcon className='icon' />
              <div><h4>Durga Puja</h4></div>
            </Link>

            <Link to="/calender/shardiya" className="calender-item">
              <Brightness5OutlinedIcon className='icon' />
              <div><h4>Sharad Navratri</h4></div>
            </Link>

            <Link to="/calender/chaitranavaratri" className="calender-item">
              <Brightness4OutlinedIcon className='icon' />
              <div><h4>Chaitra Navaratri</h4></div>
            </Link>

            <Link to="/calender/odia" className="calender-item">
              <WavesOutlinedIcon className='icon' />
              <div><h4>Odia</h4></div>
            </Link>

            <Link to="/calender/bengali" className="calender-item">
              <LanguageOutlinedIcon className='icon' />
              <div><h4>Bengali</h4></div>
            </Link>

            <Link to="/calender/gujrati" className="calender-item">
              <DiamondOutlinedIcon className='icon' />
              <div><h4>Gujrati</h4></div>
            </Link>

            <Link to="/calender/marathi" className="calender-item">
              <EmojiEmotionsOutlinedIcon className='icon' />
              <div><h4>Marathi</h4></div>
            </Link>

            <Link to="/calender/telegu" className="calender-item">
              <NightlightOutlinedIcon className='icon' />
              <div><h4>Telegu</h4></div>
            </Link>

            <Link to="/calender/iskon" className="calender-item">
              <SelfImprovementOutlinedIcon className='icon' />
              <div><h4>Iskon</h4></div>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Calenders;
